import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { servicingCommonReducer } from './servicing-common.reducer';
import { SERVICING_COMMON_STORE_NAME, ServicingCommonState } from './servicing-common.state';

/** Token of the ServicingCommon reducer */
export const SERVICING_COMMON_REDUCER_TOKEN = new InjectionToken<ActionReducer<ServicingCommonState, Action>>(
  'Feature ServicingCommon Reducer'
);

/** Provide default reducer for ServicingCommon store */
export function getDefaultServicingCommonReducer() {
  return servicingCommonReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(SERVICING_COMMON_STORE_NAME, SERVICING_COMMON_REDUCER_TOKEN)],
  providers: [{ provide: SERVICING_COMMON_REDUCER_TOKEN, useFactory: getDefaultServicingCommonReducer }],
})
export class ServicingCommonStoreModule {
  public static forRoot<T extends ServicingCommonState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<ServicingCommonStoreModule> {
    return {
      ngModule: ServicingCommonStoreModule,
      providers: [{ provide: SERVICING_COMMON_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
